import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { FinDokumentStavka } from './fin-dokument-stavka';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { KontniPlanView } from 'src/app/lookups/kontni-plan/kontni-plan-view';
import { Valuta } from 'src/app/lookups/valuta/valuta';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-fin-dokument-stavka-update',
  templateUrl: './fin-dokument-stavka-update.component.html'
})
export class FinDokumentStavkaUpdateComponent extends BaseUpdateComponent<FinDokumentStavka> implements OnInit {

  // _imaAna = false;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('OrgJedID', Validators.required, 'required', 'FINDOKUMENTSTAVKA.ORGJED.VALIDATION.REQUIRED');
    this.addValidatorToFc("KontoID", Validators.required, 'required', 'FINDOKUMENTSTAVKA.KONTO.VALIDATION.REQUIRED');
    // this.addValidatorToFc("KomitentID", checkByKontoImaAna(true, 'KomitentID'), 'checkedKonto', 'FINDOKUMENTSTAVKA.KOMITENT.VALIDATION.REQUIRED');

    this.baseFormGroup.setValidators(CheckAmounts('Duguje','Potrazuje','DDuguje','DPotrazuje'));
    this.baseFormGroup.updateValueAndValidity();
  }
  
  onDeviznoChange(){
    this.baseFormGroup.get('ValutaID').clearValidators();
    this.baseFormGroup.get('ValutaID').updateValueAndValidity();
    this.addValidatorToFc("ValutaID", checkValuta('DDuguje','DPotrazuje','ValutaID'), 'checkedValuta', 'FINDOKUMENTSTAVKA.VALUTA.VALIDATION.REQUIRED');
    this.baseFormGroup.get('ValutaID').updateValueAndValidity();

  }

//  proveraValute(dduguje:number, dpotrazuje:number, valutaID:number){
//     this.addValidatorToFc("ValutaID", checkValuta('DDuguje','DPotrazuje','ValutaID'), 'checkedValuta', 'FINDOKUMENTSTAVKA.VALUTA.VALIDATION.REQUIRED');
//     this.baseFormGroup.get('ValutaID').updateValueAndValidity();
//   }

  onKontoSelected(value : KontniPlanView){
      if (value && value.ImaAna){          
          this.baseFormGroup.get('KomitentID').enable();
          this.addValidatorToFc("KomitentID", checkByKontoImaAna(true, 'KomitentID'), 'checkedKonto', 'FINDOKUMENTSTAVKA.KOMITENT.VALIDATION.REQUIRED');
          this.baseFormGroup.get('KomitentID').updateValueAndValidity();
          this.baseFormGroup.get('Brfak').enable();
          this.addValidatorToFc("Brfak", checkByKontoImaAna(true, 'Brfak'), 'checkedKonto', 'FINDOKUMENTSTAVKA.BRFAK.VALIDATION.REQUIRED');
          this.baseFormGroup.get('Brfak').updateValueAndValidity();
          this.baseFormGroup.get('Datfak').enable();
          this.addValidatorToFc("Datfak", checkByKontoImaAna(true, 'Datfak'), 'checkedKonto', 'FINDOKUMENTSTAVKA.DATFAK.VALIDATION.REQUIRED');
          this.baseFormGroup.get('Datfak').updateValueAndValidity();
          this.baseFormGroup.get('Datdpo').enable();
          this.addValidatorToFc("Datdpo", checkByKontoImaAna(true, 'Datdpo'), 'checkedKonto', 'FINDOKUMENTSTAVKA.DATDPO.VALIDATION.REQUIRED');
          this.baseFormGroup.get('Datdpo').updateValueAndValidity();
        }
        else {
          // this._imaAna=false;
          this.baseFormGroup.get('KomitentID').disable();
          this.baseFormGroup.get('KomitentID').reset();
          this.baseFormGroup.get('Brfak').disable();
          this.baseFormGroup.get('Brfak').reset();
          this.baseFormGroup.get('Datfak').disable();
          this.baseFormGroup.get('Datfak').reset();
          this.baseFormGroup.get('Datdpo').disable();
          this.baseFormGroup.get('Datdpo').reset();
        }
        // checkByKontoImaAna(this._imaAna, 'KomitentID');
  }
  

  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}

}

 function checkByKontoImaAna(_imaAna: boolean, controlkey: string): ValidationErrors{
    return (group:FormGroup):{[key: string]: any} => {
      if (_imaAna){
        let _control= group.parent.get(controlkey) as FormControl;
        let _value = _control.value;
          if (_value == null || _value == '') return {
            checkedKonto: _value==null || _value.toString()==""? true: null
          };
          else return null;
      }
      else
         return null;
  }
}


function checkValuta(ddugujekey: string, dpotrazujekey:string, valutakey:string): ValidationErrors{
  return (group:FormGroup):{[key: string]: any} => {
    let _controldduguje= group.parent.get(ddugujekey) as FormControl;
    let _valuedduguje = _controldduguje.value;
    let _controldpotrazuje= group.parent.get(dpotrazujekey) as FormControl;
    let _valuedpotrazuje = _controldpotrazuje.value;
    let _controlvaluta= group.parent.get(valutakey) as FormControl;
    let _valuevaluta = _controlvaluta.value;

    if (_valuedduguje !== null && _valuedpotrazuje !== null){
      if ((_valuedduguje == 0 && _valuedpotrazuje == 0 && _valuevaluta == null) || ((_valuedduguje != 0 || _valuedpotrazuje !=0) && _valuevaluta != null))
        return null;
      else {
        return {
          checkedValuta : true
          };
      }
    }
    else
      return null;
  }
 
}

function CheckAmounts(dugujeKey:string, potrazujeKey: string, ddugujeKey: string, dpotrazujeKey: string){
  return (group: FormGroup): {[key : string]: any} =>{
   let duguje = group.controls[dugujeKey].value;
   let potrazuje = group.controls[potrazujeKey].value;
   let dduguje = group.controls[ddugujeKey].value;
   let dpotrazuje = group.controls[dpotrazujeKey].value;
   
   if (duguje==null && potrazuje==null && dduguje==null && dpotrazuje==null)
       return { checkAmounts :{valid:true, message:'ok'}};
   if (duguje!=0 || potrazuje!=0 || dduguje!=0 || dpotrazuje!=0)
       return null;
   if (duguje==0 && potrazuje==0 && dduguje==0 && dpotrazuje==0)
       return { checkAmounts :{valid:false, message:'FINDOKUMENTSTAVKA.AMOUNTSEMPTY'}};
     }
  }


